// extracted by mini-css-extract-plugin
export default {"quantity_container":"MG","hiddenflavorstring":"NG","loadingLine":"OG","productimgwrap":"PG","productimg":"QG","circlepic":"RG","productinfo":"SG","grey_x":"TG","cartrow":"UG","bold":"VG","title":"WG","blue":"XG","strike":"YG","flexgap":"ZG","flavorstring":"aH","nodecorate":"bH","flavorstring_link":"cH","rdstring":"eH","removeditemblock":"fH","removed_heading":"gH","removed_text":"hH","addback":"iH"};
    if(module.hot) {
      // 1714442369976
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  